import { render } from "./p-multiselect.vue?vue&type=template&id=a4a9d8b2&scoped=true"
import script from "./p-multiselect.vue?vue&type=script&lang=js"
export * from "./p-multiselect.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&external"
import "./p-multiselect.vue?vue&type=style&index=1&id=a4a9d8b2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4a9d8b2"]])

export default __exports__